import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  IconButton,
  Button,
  CircularProgress,
  Tooltip
} from '@mui/material';
import {
  Close as CloseIcon,
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon
} from '@mui/icons-material';
import XmlViewer from './XmlViewer';

export interface XmlViewerDialogProps {
  open: boolean;
  title: string;
  content: string;
  loading?: boolean;
  onClose: () => void;
}

const XmlViewerDialog: React.FC<XmlViewerDialogProps> = ({
  open,
  title,
  content,
  loading = false,
  onClose
}) => {
  const [fullScreen, setFullScreen] = useState(false);

  return (
    <Dialog
      open={open}
      onClose={() => { setFullScreen(false); onClose(); }}
      maxWidth="xl"
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{ sx: { height: fullScreen ? '100%' : '85vh' } }}
    >
      <DialogTitle sx={{ py: 1.5 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{title}</Typography>
          <Box display="flex" gap={0.5}>
            <Tooltip title={fullScreen ? 'Verkleinern' : 'Maximieren'}>
              <IconButton size="small" onClick={() => setFullScreen(fs => !fs)}>
                {fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </Tooltip>
            <IconButton size="small" onClick={() => { setFullScreen(false); onClose(); }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" flex={1}>
            <CircularProgress />
          </Box>
        ) : (
          <XmlViewer content={content} maxHeight={fullScreen ? 'calc(100vh - 160px)' : 'calc(85vh - 160px)'} />
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={() => { setFullScreen(false); onClose(); }}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
};

export default XmlViewerDialog;
